import { token } from '@atlaskit/tokens';
import { StylesConfig } from '@databases/atlaskit/Select';

export const baseSelectStyleConfig: StylesConfig<any> = {
  menu: (base) => ({
    ...base,
    width: '100%',
    minWidth: '260px',
    position: 'relative',
    boxShadow: 'none',
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0',
  }),
  control: (base) => ({
    ...base,
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
  }),
  placeholder: (base) => ({
    ...base,
    left: token('space.300', '1.5rem'),
  }),
  input: (base) => ({
    ...base,
    marginLeft: token('space.100', '0.5rem'),
    '> div > input': {
      width: '100% !important',
    },
  }),
};

export const isRenderedInSidePanelStyling: StylesConfig<any> = {
  menu: (base) => ({
    ...base,
    width: '100%',
    minWidth: '260px',
    position: 'static',
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0',
  }),
  control: (base) => ({
    ...base,
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
  }),
  placeholder: (base) => ({
    ...base,
    left: token('space.300', '1.5rem'),
  }),
  input: (base) => ({
    ...base,
    marginLeft: token('space.100', '0.5rem'),
    '> div > input': {
      width: '100% !important',
    },
  }),
};
